// src/components/PickedRow.js
// What was chosen in a picker, with a Change button to pick again (10/29).
import React from 'react';

export default function PickedRow({ icon, label, sub, onChange, changeLabel = 'Change' }) {
  return (
    <div className="card picked-row" style={{ marginBottom: 14 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ fontSize: '1.3rem' }}>{icon}</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ fontWeight: 700 }}>{label}</p>
          {sub && <p style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>{sub}</p>}
        </div>
        {onChange && (
          <button className="btn btn-ghost" style={{ width: 'auto', minHeight: 34, padding: '0 12px', fontSize: '0.85rem' }}
            onClick={onChange}>{changeLabel}</button>
        )}
      </div>
    </div>
  );
}
